<template>
  <Transition name="fade">
    <div class="xy-loading" v-show="visible">
      <div class="xy-loading-content">
        <i class="loading rotate-element"><svg-icon name="loading" /></i>
        <span class="text" v-if="message">{{ props.message }}</span>
      </div>
    </div>
  </Transition>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import SvgIcon from '@/h5/components/SvgIcon/index.vue'

const props = defineProps({
  message: {
    type: String,
    default: ''
  }
})

const visible = ref(false)

onMounted(() => {
  visible.value = true
})
</script>
<style scoped lang="scss">
.xy-loading {
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.3);

  .xy-loading-content {
    width: auto;
    max-width: calc(100% - 2.5rem);
    min-height: 2.125rem;
    line-height: 2.125rem;
    padding: 0 0.75rem;
    border: 0.0625rem solid rgba(0, 0, 0, 0.75);
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    .loading {
      margin: 0.5rem 0 0.375rem 0;
      font-size: 2.125rem;
    }

    .text {
      vertical-align: middle;
    }
  }
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

@keyframes rotateAnimation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.rotate-element {
  animation: rotateAnimation 2s linear infinite;
}
</style>
